import gql from 'graphql-tag';

const cancelEmailChangeUserMutation = gql`
  mutation CancelEmailChangeUserMutation($token: String!) {
    data: cancelEmailChangeUserMutation(token: $token) {
      title
      message
    }
  }
`;

export default cancelEmailChangeUserMutation;
